import { useConfigTypeTitle } from '@eggplant/routing'

const NoAvailableFeature = () => {
  const configTypeText = useConfigTypeTitle()

  return (
    <>
      If your new feature is not listed above, please
      refresh this page. Save your {configTypeText} config beforehand
      to avoid losing changes.
    </>
  )
}

export default NoAvailableFeature
